document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-influencer-card]').forEach((card) => {
    const poster = card.querySelector('[data-local-video-poster]');
    const localVideo = card.querySelector('[data-local-video]');
    if (poster && localVideo) {
      poster.addEventListener('click', () => {
        poster.hidden = true;
        localVideo.classList.remove('is-covered');
        const video = localVideo.querySelector('video');
        if (video) video.play().catch(() => {});
      });
    }

    const shell = card.querySelector('[data-social-embed]');
    if (!shell) return;

    const url = card.dataset.url || '';
    const platform = card.dataset.platform || '';
    const iframe = buildEmbed(url, platform);

    if (iframe) {
      shell.innerHTML = '';
      shell.appendChild(iframe);
    } else {
      shell.innerHTML = '<div class="influencer-empty">この投稿は自動表示できません。<br>下の「元の投稿を見る」からご覧ください。</div>';
    }
  });
});

function buildEmbed(url, platform) {
  if (platform === 'YouTube') {
    const id = getYouTubeId(url);
    if (!id) return null;
    return makeIframe(`https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}`, 'YouTube動画');
  }

  if (platform === 'Instagram') {
    try {
      const u = new URL(url);
      if (!u.hostname.includes('instagram.com')) return null;
      const clean = `${u.origin}${u.pathname}`.replace(/\/+$/, '');
      return makeIframe(`${clean}/embed/captioned/`, 'Instagram投稿', 'instagram-embed-frame');
    } catch (e) {
      return null;
    }
  }

  if (platform === 'TikTok') {
    const match = url.match(/\/video\/(\d+)/);
    if (!match) return null;
    return makeIframe(`https://www.tiktok.com/player/v1/${match[1]}?autoplay=0&loop=0`, 'TikTok動画', 'tiktok-embed-frame');
  }

  return null;
}

function makeIframe(src, title, extraClass = '') {
  const iframe = document.createElement('iframe');
  iframe.src = src;
  iframe.title = title;
  iframe.loading = 'lazy';
  iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; clipboard-write';
  iframe.allowFullscreen = true;
  iframe.referrerPolicy = 'strict-origin-when-cross-origin';
  iframe.className = `social-embed-frame ${extraClass}`.trim();
  return iframe;
}

function getYouTubeId(url) {
  try {
    const u = new URL(url);
    if (u.hostname === 'youtu.be') return u.pathname.slice(1).split('/')[0];
    if (u.hostname.includes('youtube.com')) {
      if (u.pathname.startsWith('/shorts/')) return u.pathname.split('/')[2];
      if (u.pathname.startsWith('/embed/')) return u.pathname.split('/')[2];
      return u.searchParams.get('v');
    }
  } catch (e) {}
  return null;
}
